import React, { Component } from 'react';
import { formatCurrency } from '@C/TableGrid';
import { Fuel } from 'lucide-react';

export class FuelSummary extends Component {
  constructor() {
    super();
  }

  render() {
    const gun_wise = this.props.gun_wise.sort(
      (a, b) => b.gun_name - a.gun_name,
    );
    return (
      <>
        <section className="widget full-width dsr-table">
          <header>
            <Fuel color="#31af36" />
            <h3>Fuel Sales Summary</h3>
          </header>
          <main className="content-wrapper">
            <table className="dsr" data-name="Fuel Sales">
              <thead>
                <tr data-header={true}>
                  <th>Gun</th>
                  <th>Staff</th>
                  <th>Shift</th>
                  <th>Opening</th>
                  <th>Closing</th>
                  <th>Testing</th>
                  <th>Bowser</th>
                  <th>Litres sold</th>
                  <th>Rate/litre</th>
                  <th>Total amount</th>
                </tr>
              </thead>
              <tbody>
                {gun_wise.map((val, key) => {
                  return (
                    <tr key={key}>
                      <td>{val.gun_name}</td>
                      <td>{`${
                        val.cashier_first_name || '--'
                      } ${val.cashier_last_name || ''}`}</td>
                      <td>{val.shift}</td>
                      <td>{val.opening_reading}</td>
                      <td>{val.closing_reading}</td>
                      <td>{val.testing_liters}</td>
                      <td>{formatCurrency(val.bowser_total)}</td>
                      <td>
                        {val.litters_sold > 0
                          ? val.litters_sold.toFixed(2)
                          : 0.0}
                      </td>
                      <td>{formatCurrency(val.price)}</td>
                      <td>{formatCurrency(val.total_amount)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </main>
        </section>
      </>
    );
  }
}
